// easing equations from https://github.com/danro/easing-js/blob/master/easing.js
const easeOutSine = pos => Math.sin(pos * (Math.PI / 2));
const easeInOutSine = pos => -0.5 * (Math.cos(Math.PI * pos) - 1);
const easeInOutQuint = pos => {
  const halfPos = pos / 0.5;
  if (halfPos < 1) {
    return 0.5 * halfPos ** 5;
  }
  return 0.5 * ((halfPos - 2) ** 5 + 2);
};

// as in https://stackoverflow.com/a/26808520
// scrollTargetY: the target scrollY property of the window
// speed: time in pixels per second
// easing: easing equation to use
function scrollToY(scrollTargetY, speed, easing) {
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  var scrollTargetY = scrollTargetY || 0;
  var speed = speed || 1500;
  var easing = easing || easeInOutQuint;
  let currentTime = 0;

  // min time .1, max time .8 seconds
  const time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8));

  // add animation loop
  function tick() {
    currentTime += 1 / 60;

    const p = currentTime / time;
    const t = easing(p);

    if (p < 1) {
      window.requestAnimationFrame(tick);

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
    } else {
      window.scrollTo(0, scrollTargetY);
    }
  }

  // call it once to get started
  tick();
}

function scrollElementToCenter(element, speed, easing) {
  const middleOfElement = element.offsetTop + element.offsetHeight / 2;
  const desiredOffset = middleOfElement - window.innerHeight / 2;

  scrollToY(desiredOffset, speed, easing);
}

function scrollElementToTop(element, speed, easing) {
  scrollToY(element.offsetTop, speed, easing);
}

export { easeOutSine, easeInOutSine, easeInOutQuint, scrollElementToCenter, scrollElementToTop, scrollToY };
